export default "__VITE_ASSET__KzuP8fGZ__"